import React from 'react';
import { Link } from 'react-router-dom';
import ProfileImageWithProgress from './ProfileImageWithProgress';
import SocialConnections from './SocialConnections';

const ProfileCard = ({ 
  userInfo,
  completion, 
  socialAccounts, 
  onEditClick, 
  token, 
  dispatch,
  fetchSocialAccounts,
  isLinking,
  setIsLinking
}) => {

  return (
    <div className="prof-card">
      <ProfileImageWithProgress 
        userInfo={userInfo}
        completion={completion}
        token={token}
        dispatch={dispatch}
      />

      {/* User Info Section */}
      <UserInfoSection userInfo={userInfo} onEditClick={onEditClick} />

      {/* Social Connections */}
      <SocialConnections 
        socialAccounts={socialAccounts}
        token={token}
        fetchSocialAccounts={fetchSocialAccounts}
        isLinking={isLinking}
        setIsLinking={setIsLinking}
      />
    </div>
  );
};

const UserInfoSection = ({ userInfo, onEditClick }) => (
  <div className="section d-flex justify-content-between align-items-center">
    <div>
      <div className="title">{userInfo?.first_name} {userInfo?.last_name}</div>
      <div className="small text-muted">{userInfo.profileId}</div>
    </div>
    <Link href="#" onClick={onEditClick} className="small fw-semibold text-decoration-none" style={{ color: '#df8525' }}>
      Edit
    </Link>
  </div>
);

export default ProfileCard;